import { useState, useEffect, useMemo } from "react";
import { Icon } from "semantic-ui-react";

export default function ClipboardCopyButton({ value }: { value: string }) {
  const [copied, setCopied] = useState<boolean>(false);

  const message = useMemo(() => {
    if (copied) return "Copied!";
    return "Copy to clipboard";
  }, [copied, value]);

  useEffect(() => {
    if (copied) setTimeout(() => setCopied(false), 3000);
  }, [copied]);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (error) {
      console.error("Failed to copy to clipboard:", error);
    }
  };

  return (
    <span
      className="copy-clipboard"
      tabIndex={0}
      style={{
        cursor: "pointer",
        minWidth: "150px",
        color: "var(--highlight-primary-2)",
        display: "inline-block",
      }}
      role="button"
      onClick={handleClick}
    >
      <Icon name="copy" style={{ color: "var(--text-4)" }} />
      {message}
    </span>
  );
}
